module.exports = __webpack_public_path__ + "static/media/white-spades.b2e17b08.svg";